
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/2023-toolpad-beta-announcement",
      function () {
        return require("private-next-pages/blog/2023-toolpad-beta-announcement.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/2023-toolpad-beta-announcement"])
      });
    }
  